import { Component, input, computed } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    imports: []
})
export class ProgressBarComponent {
  value = input<number>(0);
  max = input<number>(100);
  variant = input<'default' | 'text-inside'>('default');

  percentage = computed(() => {
    const maxVal = this.max();
    if (!maxVal || maxVal === 0) {
      return 0;
    }
    const calculatedPercentage = (this.value() / maxVal) * 100;
    return Math.min(Math.round(calculatedPercentage), 100);
  });
}
